import Dashboard from '~/components/Dashboard'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'

export const getStaticProps = async () => {
  const t = i18n.t

  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/lon/dashboard`,
          key: 'ogurl',
        },
        {
          property: 'og:title',
          content: t('meta_lon_dashboard_title'),
          key: 'ogtitle',
        },
        {
          property: 'og:description',
          content: t('meta_lon_dashboard_description'),
          key: 'ogdesc',
        },
      ],
    },
  }
}

export default Dashboard
